<div class="ticket-container">
    <!-- Ticket Header -->
    <div class="ticket-header">
        <div class="event-name">
            <h3>{{ ticket?.voucherName | titlecase }}</h3>
        </div>
        <div *ngIf='false' class="ticket-logo">
            <span>ADMIT ONE</span>
        </div>
    </div>
    
    <!-- Ticket Body -->
    <div class="ticket-body">
        <div class="ticket-info">
            <div class="info-row">
                <span class="label">Date:</span>
                <span class="value">{{ eventDate || 'TBD' }}</span>
            </div>
            <div class="info-row">
                <span class="label">#:</span>
                <span class="value ticket-id small-text">{{ ticket?.barcode }}</span>
            </div>
            <div class="info-row">
                <span class="label">Info :</span>
                <span class="value ticket-id info-text">{{ ticket?.seat || 'General Admission' }}</span>
            </div>
        </div>
        
        <!-- QR Code Section -->
        <div class="qr-section">
            <div class="qr-container">
                <qrcode
                    [qrdata]="ticket?.barcode"
                    [allowEmptyString]="true"
                    [ariaLabel]="'QR Code for ticket'"
                    [colorDark]="'#000000ff'"
                    [colorLight]="'#ffffffff'"
                    [elementType]="'canvas'"
                    [errorCorrectionLevel]="'H'"
                    [margin]="2"
                    [scale]="1"
                    [title]="'Allxs QR Code'"
                    [width]="200">
                </qrcode>
            </div>
        </div>
    </div>
    
    <!-- Ticket Footer -->
    <div class="ticket-footer">
        <div class="perforated-line"></div>
        <button class="download-button" (click)="onDownloadTicket()">
            <i class="fa fa-download"></i> Download Ticket
        </button>
    </div>
</div>